export const allowRedirectBeforeRouteLeave = {
  data () {
    return {
      continueRedirect: true
    }
  },
  methods: {
    allowRedirect () {
      this.continueRedirect = true
    },
    disallowRedirect () {
      this.continueRedirect = false
    },
    redirect (to) {
      this.$router.push({ path: to.path, query: to.query, params: to.params })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.continueRedirect || this.$store.getters.getAuthUserForceRedirect) {
      next()
    } else {
      if (this.$refs.popNotify.isActive) {
        next()
      } else {
        this.$refs.popNotify.openNotify()
        this.$refs.popNotify.customRedirectTo = to
      }
    }
  }
}

export const validateAllowRedirectBeforeRouteLeave = {
  data () {
    return {
      validated: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.validated && !this.$store.getters.getAuthUserForceRedirect) {
      this.$refs.childcomponent.validateBeforeRouteLeave(to)
    } else {
      this.validated = false
      next()
    }
  }
}

export const validateBeforeRouteLeave = {
  methods: {
    validateBeforeRouteLeave: function (to) {
      if (to.name.includes(`${this.rootItemName}-edit`) || to.name.includes(`${this.rootItemName}-add`)) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$parent.validated = true
            this.$router.push({ name: to.name, path: to.path, query: to.query, params: to.params })
          } else {
            this.$refs.popnotifyvalidation.openNotify()
          }
        })
      } else {
        this.$parent.validated = true
        this.$router.push({ name: to.name, path: to.path, query: to.query, params: to.params })
      }
    },
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit(`${this.rootItemName}-submit`)
    }
  }
}

export const performValidate = {
  methods: {
    performValidate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            resolve()
          } else {
            if (this.performSubmitValidateValidationCallback) {
              this.performSubmitValidateValidationCallback()
            }
            this.$refs.popnotifyvalidation.openNotify()
            reject()
          }
        })
      })
    }
  }
}

export const performSubmitValidate = {
  methods: {
    performSubmitValidate (data) {
      console.log('1 performSubmitValidate')
      const allowThenCallback = data ? data.allowThenCallback : true
      const allowCatchCallback = data ? data.allowCatchCallback : true
      const allowFinallyCallback = data ? data.allowFinallyCallback : true
      const customPayload = data ? data.payload : undefined
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.allowRedirectBeforeRouteLeave()
          const routeName = this.$route.name
          const routeNameHasAdd = routeName.includes(`${this.rootItemName}-add`)
          const routeNameHasEdit = routeName.includes(`${this.rootItemName}-edit`)

          if (routeNameHasAdd || routeNameHasEdit) {
            this.$store.dispatch(routeNameHasAdd ? this.nameActionCreate : this.nameActionUpdate, customPayload !== undefined ? customPayload : (routeNameHasAdd ? this.paramsActionCreate : this.paramsActionUpdate)).then(response => {
              if (this.performSubmitValidateThenCallback && allowThenCallback) {
                this.performSubmitValidateThenCallback(response)
              }
            }).catch(error => {
              if (this.performSubmitValidateCatchCallback && allowCatchCallback) {
                this.performSubmitValidateCatchCallback(error)
              }
            }).finally(() => {
              if (this.performSubmitValidateFinallyCallback && allowFinallyCallback) {
                this.performSubmitValidateFinallyCallback()
              }
            })
          }
        } else {
          if (this.performSubmitValidateValidationCallback) {
            this.performSubmitValidateValidationCallback()
          }
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    }
  }
}

export const performSubmitValidatePromise = {
  methods: {
    performSubmitValidatePromise (redirect = true) {
      const route = this.$route.name
      let actionName
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (route.includes(`${this.rootItemName}-add`)) {
              actionName = this.nameActionCreate
            } else if (route.includes(`${this.rootItemName}-edit`)) {
              actionName = this.nameActionUpdate
            }
            this.$store.dispatch(actionName, redirect).then((response) => {
              resolve(response)
            }).catch((error) => {
              reject(error)
            })
            this.allowRedirectBeforeRouteLeave()
          } else {
            this.$refs.popnotifyvalidation.openNotify()
            const validationError = 'No validation'
            reject(validationError)
          }
        })
      })
    }
  }
}

export const performReset = {
  methods: {
    performReset () {
      this.$store.dispatch(`${this.nameActionReset}`)
      this.$validator.reset()
    }
  }
}

export const watchContentChangeEmit = {
  data () {
    return {
      preventWatchContent: true
    }
  },
  watch: {
    watchContent () {
      if (this.preventWatchContent) {
        return
      }
      this.$eventBus.$emit('content-change')
    }
  },
  methods: {
    clearContentChange () {
      this.$eventBus.$emit('clear-content-change')
    }
  },
  mounted () {
    setTimeout(() => {
      this.preventWatchContent = false
    }, 2500)
  }
}

export const watchContentChangePreventRedirect = {
  data () {
    return {
      continueRedirect: true
    }
  },
  methods: {
    allowRedirect () {
      this.continueRedirect = true
    },
    disallowRedirect () {
      this.continueRedirect = false
    }
  },
  mounted () {
    this.$eventBus.$on('content-change', () => {
      this.disallowRedirect()
    })
    this.$eventBus.$on('clear-content-change', () => {
      this.allowRedirect()
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('content-change')
    this.$eventBus.$off('clear-content-change')
  }
}
